import { Component, OnInit } from '@angular/core';
import { AuthService } from '../components/auth/auth.service';
@Component({
  selector: 'app',
  template: require('./app.component.html')
})

export class AppComponent implements OnInit {
  static parameters = [AuthService]
  constructor(
    private auth: AuthService,
  ) { }

  ngOnInit() {
    console.log('auth.loggedIn', this.auth.loggedIn)
  }
}